<template>
  <form :class="{'AdminForm':true}" method="post" @submit.prevent autocomplete="false">
    <div class="form-fields-container">
      <div class="form-two-columns">
        <select class="SelectField" name="agent_id" v-model="formValues.agent_id" required
                :class="formValues.agent_id == null ? 'placeholder_mode' : ''">
          <option selected="selected" disabled :value="null">Medewerker</option>
          <option :value="createFullName(agent.employee.firstname, agent.employee.infix, agent.employee.lastname)" v-for="agent in agents" :key="agent.employee.id">
            {{
              createFullName(agent.employee.firstname, agent.employee.infix, agent.employee.lastname)
            }}
          </option>
        </select>
        <span v-if="errors.includes('agent_id')" class="form-error">Medewerker mag niet leeg zijn</span>
      </div>
      <div class="form-two-columns">
        <input type="number" v-model="formValues.customer_number"
               placeholder="Klantnummer van aanbrenger"
               name="customer_number">
        <span v-if="errors.includes('customer_number')" class="form-error">Klantnummer mag niet leeg
          zijn</span>
      </div>
      <div class="form-two-columns">
        <input type="text" v-model="formValues.postal_code" @keyup="getAddressInfo"
               @focusout="formValues.postal_code = formValues.postal_code.toUpperCase()"
            placeholder="Postcode"
               autocapitalize="on"
               name="postalcode">
        <span v-if="errors.includes('postal_code')" class="form-error">De postcode moet bestaan uit vier
          cijfers gevolgd door twee letters, zonder spaties</span>
      </div>
      <div class="form-two-columns">
        <input type="text" v-model="formValues.street_number" @keyup="getAddressInfo" placeholder="Huisnummer"
               name="streetnumber">
        <span v-if="errors.includes('street_number')" class="form-error">Huisnummer mag niet leeg zijn</span>
      </div>
      <div class="form-two-columns">
        <input type="text" disabled="disabled" readonly v-model="formValues.street_name" placeholder="Straat"
               name="streetname">
        <span v-if="errors.includes('street_name')" class="form-error">Straat mag niet leeg zijn</span>
      </div>
      <div class="form-two-columns">
        <input type="text" disabled="disabled" readonly v-model="formValues.city" placeholder="Plaats"
               name="city">
        <span v-if="errors.includes('city')" class="form-error">Plaats mag niet leeg zijn</span>
      </div>
      <div>
        <input type="text" v-model="formValues.initial" placeholder="Voorletter" name="initial"
               @focusout="formValues.initial = formatInitials(formValues.initial)" autocapitalize="on">
        <span v-if="errors.includes('initial')" class="form-error">Voorletter moet een hoofdletter zijn
        gevolgd door een punt: A.</span>
      </div>
      <div>
        <input type="text" v-model="formValues.insertion" placeholder="Tussenvoegsel" name="insertion">
      </div>
      <div class="form-two-columns">
        <input v-model="formValues.last_name" type="text" placeholder="Achternaam" autocapitalize="words"
               @focusout="formValues.last_name = capitalizeWords(formValues.last_name)"
               name="lastname">
        <span v-if="errors.includes('last_name')" class="form-error">Achternaam mag niet leeg zijn</span>
      </div>
      <div class="form-two-columns">
        <input v-model="formValues.phone_number" type="text"
               placeholder="Telefoonnummer" name="phone_number">
        <span v-if="errors.includes('phone_number')" class="form-error">Telefoonnummer moet een valide
          telefoonnummer zijn</span>
      </div>
      <div class="form-two-columns">
        <input type="text" v-model="formValues.email" placeholder="E-mailadres"
               name="email">
        <span v-if="errors.includes('email')" class="form-error">E-mailadres moet een valide
          e-mailadres zijn</span>
      </div>
    </div>
    <Button :primary="true" type="submit" :disabled="saving === true" @click="submitForm">
      Toevoegen
    </Button>
  </form>
</template>

<script>
  import Button from "@/components/Button";
  import {mapActions, mapState} from "vuex";
  import {capitalizeWords, createFullName, formatInitials} from "../common/forms-util";
  import {
    validateEmail, validateEmptyString, validateInitial, validateNotNull,
    validatePhoneNumber, validatePostalCode, validateStreetNumber
  } from "../common/validators";

  export default {
    components: {
      Button
    },
    props: ['formType'],
    data() {
      return {
        errors: [],
        saving: false,
        formValues: {
          agent_id: null,
          customer_number: null,
          postal_code: "",
          street_number: "",
          street_name: "",
          city: "",
          municipality: "",
          province: "",
          latitude: "",
          longitude: "",
          initial: "",
          insertion: "",
          last_name: "",
          phone_number: "",
          email: "",
        },
        formValidators: {
          agent_id: validateNotNull,
          initial: validateInitial,
          last_name: validateEmptyString,
          phone_number: validatePhoneNumber,
          email: validateEmail
        },
        addressTimeout: null
      };
    },

    computed: {
      ...mapState('data', {
        agents: 'agents'
      })
    },

    methods: {
      ...mapActions({
        createCompany: "map/createCompany",
        fetchAgents: 'data/fetchAgents'
      }),
      createFullName: createFullName,
      capitalizeWords: capitalizeWords,
      formatInitials: formatInitials,

      async submitForm() {
        if (this.saving) {
          return;
        }
        this.saving = true;
        this.validateFields();
        if (this.errors.length > 0) {
          this.saving = false;
          return;
        }

        try {
          const savingCompany = await this.createCompany({
            kmkEmployee: this.formValues.agent_id,
            kmk: this.formValues.customer_number,
            postal_code: this.formValues.postal_code,
            street_number: this.formValues.street_number,
            street_name: this.formValues.street_name,
            city: this.formValues.city,
            municipality: this.formValues.municipality,
            province: this.formValues.province,
            latitude: this.formValues.latitude.toString(),
            longitude: this.formValues.longitude.toString(),
            direct_mailing: this.formValues.direct_mailing,
            initial: this.formValues.initial,
            insertion: this.formValues.insertion,
            last_name: this.formValues.last_name,
            phone_number: this.formValues.phone_number,
            email: this.formValues.email,
            dmBron: "kmk"
          });

          this.$notify({
            group: "app",
            title: "Admin",
            type: "success",
            text: "Relatie opgeslagen."
          });
          this.clearFields();
          this.saving = false;
          this.$emit('saved', this);
        } catch(error) {
          this.$notify({
            group: "app",
            title: "Admin",
            type: "error",
            text: "Relatie kon niet opgeslagen worden."
          });
          this.saving = false;
        }
      },

      clearFields() {
        this.formValues = {
          agent_id: null,
          customer_number: null,
          postal_code: "",
          street_number: "",
          street_name: "",
          city: "",
          municipality: "",
          province: "",
          latitude: "",
          longitude: "",
          initial: "",
          insertion: "",
          last_name: "",
          phone_number: "",
          email: "",
        };
      },

      checkIfCoordinatesPresent(response) {
        return response.result != null &&
            response.result.hasOwnProperty("location") &&
            response.result.location.hasOwnProperty("coordinates") &&
            response.result.location.coordinates.length === 2
      },

      validateFields() {
        for (const [field, validationResult] of Object.entries(this.formValidators)) {
          const value = this.formValues[field];
          validationResult(value) !== true ? this.errors.push(field) : this.removeFormErrors(field);
        }
      },

      removeFormErrors(value) {
        this.errors = this.errors.filter(error => error !== value);
      },

      getAddressInfo() {
        // Always clear timout to prevent unnecessary requests
        if (this.addressTimeout) {
          clearTimeout(this.addressTimeout);
        }

        if (this.formValues.postal_code === "" || this.formValues.street_number === "") {
          return;
        }
        const regex = /^([+\s0-9]+)[-]?[a-zA-Z]*[0-9]*$/;
        const matches = regex.exec(this.formValues.street_number);
        if(matches.length < 2) {
          return;
        }
        const streetNumber = matches[1];

        this.addressTimeout = setTimeout(() => {

          const url =
              `/look-up-postal-code?postalCode=${this.formValues.postal_code}&streetNumber=${streetNumber}`;
          fetch(url, {
            method: "GET",
          }).then((response) => {
            if (response.status === 200) {
              return response.json();
            }
          }).then((response) => {
            if (response.error) {
              throw new Error(response.error);
            }

            this.formValues.city = response.result.city == null ? "" : response.result.city;
            this.formValues.street_name = response.result.street == null ? "" : response.result.street;
            this.formValues.municipality = response.result.municipality == null ? "" : response.result.municipality;
            this.formValues.province = response.result.province == null ? "" : response.result.province;
            this.formValues.latitude = this.checkIfCoordinatesPresent(response) === false ? "" :
                response.result.location.coordinates[1];
            this.formValues.longitude = this.checkIfCoordinatesPresent(response) === false ? "" :
                response.result.location.coordinates[0];
          }).catch((error) => {
            this.formValues.street_name = "";
            this.formValues.city = "";
            this.formValues.municipality = "";
            this.formValues.province = "";
            this.formValues.latitude = "";
            this.formValues.longitude = "";
            this.$notify({
              group: "app",
              title: "Adres",
              type: "error",
              text: error
            });
          });
        }, 500);
      }
    },
    async mounted() {
      await this.fetchAgents();
    }
  }
</script>
